import { getApiBaseUrl, safeApiRequest } from './apiClient';

export const fetchPublicLegalDocument = async (typeOrSlug, lang) => {
  const params = new URLSearchParams();
  if (lang === 'en' || lang === 'tr') {
    params.set('lang', lang);
  }
  const qs = params.toString();
  const res = await fetch(
    `${getApiBaseUrl()}/api/public/legal-documents/${encodeURIComponent(typeOrSlug)}${qs ? `?${qs}` : ''}`,
  );
  return res.json();
};

export const fetchAdminLegalDocuments = async () =>
  safeApiRequest('/api/admin/legal-documents', { method: 'GET', skipCsrf: true });

export const updateAdminLegalDocument = async (type, payload) =>
  safeApiRequest(`/api/admin/legal-documents/${encodeURIComponent(type)}`, {
    method: 'PUT',
    body: payload,
    skipCsrf: false,
  });
